import Button from 'components/ui-kit/Button/Button';
import Modal from 'components/ui-kit/Modal/Modal';
import { useTranslation } from 'react-i18next';

type CancelOrderModalProps = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

export const CancelOrderModal = ({ open, onClose, onConfirm }: CancelOrderModalProps) => {
  const { t } = useTranslation();

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={t('pages.my-orders.sure')}
      contentPaddingInline={24}
      actions={
        <>
          <Button buttonType="outlined" size="medium" fullWidth onClick={onConfirm}>
            {t('common.cancel-order')}
          </Button>
          <Button buttonType="primary" size="medium" fullWidth onClick={onClose}>
            {t('common.keep-order')}
          </Button>
        </>
      }
    >
      <div className="cancel-order-modal-content">
        <p>{t('pages.my-orders.fees-if-reckless')}</p>
      </div>
    </Modal>
  );
};
